import { useQuery } from '@tanstack/react-query';
import { mobileAdminQueryKeys } from '../query';
import { entitlementAdminApi } from './api';

export function useEntitlementDiagnostics(studentId: string, enabled: boolean) {
    return useQuery({
        queryKey: mobileAdminQueryKeys.entitlements(studentId),
        queryFn: () => entitlementAdminApi.get(studentId),
        enabled: enabled && Boolean(studentId),
        retry: false,
    });
}
